import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCardTitle,[_c('h6',[_vm._v("\n      "+_vm._s(_vm.$tt('customFieldHeader'))+"\n    ")])]),_c(VCardText,[_c(VSelect,{attrs:{"items":_vm.fieldsWithNameAndMine,"item-text":"name","itemValue":_vm.fieldValue,"label":"","multiple":_vm.multiple,"chips":"","hint":_vm.$tt('customPlantingFieldSelectionHint'),"persistent-hint":"","error":_vm.error,"errorMessages":_vm.errorMessage},model:{value:(_vm.pks),callback:function ($$v) {_vm.pks=$$v},expression:"pks"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }